import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IShopSmtp } from '@/shared/model/shop-smtp.model';

const baseApiUrl = 'api/v1/shop-smtps';
const baseApiUrlSmtp = 'api/v1/emails';

export default class ShopSmtpService {
  public find(id: number, shopId?: number): Promise<IShopSmtp> {
    return new Promise<IShopSmtp>((resolve, reject) => {
      let searchUrl = `${baseApiUrl}`;
      if (id) searchUrl += `/${id}`;
      if (shopId) searchUrl += `?searchAnd=shop_id==${shopId}`;
      axios
        .get(searchUrl)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public smtpTest(entity: IShopSmtp): Promise<IShopSmtp> {
    return new Promise<IShopSmtp>((resolve, reject) => {
      axios
        .post(`${baseApiUrlSmtp}/test-smtp`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IShopSmtp): Promise<IShopSmtp> {
    return new Promise<IShopSmtp>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IShopSmtp): Promise<IShopSmtp> {
    const { id } = entity;
    return new Promise<IShopSmtp>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
